import DOMPurify from 'dompurify';

const Text = ({ text }) => {
    return (
        <div>
            <p
                className="flex-grow-1 px-1"
                style={{
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    whiteSpace: 'pre-wrap',
                }}
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(text),
                }}
            />
        </div>
    );
};

export default Text;
